module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"list-group\" role=\"tablist\"> ")
    ;  for (var i = 0; i < locals.tabs.length; i++) { 
    ; __append(" ")
    ;  var tab = locals.tabs[i]; 
    ; __append(" <a href=\"#")
    ; __append(escapeFn( locals.prefix ))
    ; __append("-step")
    ; __append(escapeFn( i ))
    ; __append("\" class=\"list-group-item list-group-item-action ")
    ;  if (i === locals.activeIndex) { 
    ; __append(" active ")
    ;  } 
    ; __append("\" data-toggle=\"list\" data-step=\"")
    ; __append(escapeFn( i ))
    ; __append("\"> ")
    ; __append(escapeFn( i+1 ))
    ; __append(". ")
    ; __append(escapeFn( tab.text ))
    ; __append(" ")
    ;  if (tab.success) { 
    ; __append(" <span class=\"fa fa-check text-success tab-status\"></span> ")
    ;  } else if (tab.error) { 
    ; __append(" <span class=\"fa fa-exclamation-circle text-danger tab-status\" data-toggle=\"tooltip\" data-container=\"body\" title=\"")
    ; __append(escapeFn( tab.error ))
    ; __append("\"></span> ")
    ;  } 
    ; __append(" </a> ")
    ;  } 
    ; __append(" </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/shipments/create/modal/tabs_template.ejs
// module id = 1825
// module chunks = 1